__turbopack_context__.v({
  "captcha": "bQTH9q_captcha",
  "wrapper": "bQTH9q_wrapper",
});
